import { MatInputModule } from "@angular/material/input";
import { TranslateModule } from "@ngx-translate/core";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { Component, HostListener, ViewEncapsulation, forwardRef, input, output } from "@angular/core";

import { ValidationHandlerPipe } from "../../pipes";
import { ReactiveFormsBaseComponent } from "../../base-components";

@Component({
  selector: "app-input-text",
  standalone: true,
  imports: [TranslateModule, ReactiveFormsModule, MatInputModule, ValidationHandlerPipe],
  templateUrl: "./input-text.component.html",
  styleUrl: "./input-text.component.scss",
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTextComponent),
      multi: true,
    },
  ],
})
export class InputTextComponent extends ReactiveFormsBaseComponent {
  readonly label = input.required<string>();
  readonly readonly = input(false);
  readonly inputType = input<"textbox" | "textarea">("textbox");
  readonly contentType = input<"text" | "email" | "password" | "number">("text");
  readonly placeholder = input<string>();
  readonly matErrorClass = input("");

  readonly inputValue = output();

  onKeyPress(event: KeyboardEvent): void {
    if (this.contentType() === "number" && ["e", "+", "-"].includes(event.key.toLowerCase())) {
      event.preventDefault();
    }
  }

  @HostListener("paste", ["$event"]) onPaste(event: ClipboardEvent): void {
    if (this.contentType() === "number" && ["e", "+", "-"].includes(event.clipboardData?.getData("text/plain").toLowerCase()!)) {
      event.preventDefault();
    }
  }
}
